import { EmailService } from '../../providers'

const EmailModule = {
  namespaced: true,
  actions: {
    async fetchEmailCreateOrderById (context, orderId) {
      const result = await EmailService.fetchEmailCreateOrderById(orderId)
      return result
    }
  }
}

export default EmailModule
